import {
    GET_DAYS_WEEK_BY_COMPANIES,
    GET_DAYS_WEEK_BY_COMPANIES_SUCCESS,
    GET_DAYS_WEEK_BY_COMPANIES_API_ERROR
} from "./actionTypes"


const initialState = {
    loading: false,
    loading_form: false,
    error: false,
    message: '',

    rows: [],
    id: 0,
}

const companies = (state = initialState, action) => {

    switch (action.type) {
        case GET_DAYS_WEEK_BY_COMPANIES:
            state = {
                ...state,
                loading: true
            }
            break
        case GET_DAYS_WEEK_BY_COMPANIES_SUCCESS:
            state = {
                ...state,
                message: action.payload.message,
                error: action.payload.error,
                rows: action.payload.results,
                loading: false
            }
            break
        case GET_DAYS_WEEK_BY_COMPANIES_API_ERROR:
            state = { ...state, error: action.payload, loading: false }
            break

        default:
            state = { ...state }
            break
    }

    return state
}
export default companies
